import { BlockTitle } from '~/components/atoms/block-title';
import { Link } from '~/components/ui/link';
import { Title, TITLE_TYPE } from '~/components/ui/title';
import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';

import bgImg1 from './assets/bgImg1.png';
import bgImg2 from './assets/bgImg2.png';
import bgImg3 from './assets/bgImg3.png';
import bgImg4 from './assets/bgImg4.png';
import bgImg5 from './assets/bgImg5.png';
import bgImg6 from './assets/bgImg6.png';
import Card from './card/Card';
import { StyledCardsWrapper, StyledContainer, StyledThreeCards, StyledTitle } from './styled';

const LIST = [
  [
    {
      id: 1,
      text: (
        <div>
          <Link to={PATH.LOGIN} fontWeight={400}>
            Log in
          </Link>{' '}
          or{' '}
          <Link to={PATH.SIGN_UP} fontWeight={400}>
            Sign up
          </Link>{' '}
          to QR Code Generator select the type of QR code you want to incorporate into your menus. You can start with a{' '}
          {/* TODO*/}
          {/* set correct link*/}
          <Link fontWeight={400} to={PATH.UNAUTH.MAIN}>
            Menu QR code
          </Link>
          .
        </div>
      ),
      img: bgImg1,
    },
    {
      id: 2,
      text: 'Enter your website link and your QR code will be generated automatically.',
      img: bgImg2,
    },
    {
      id: 3,
      text: 'Customize the design of your QR code: add a frame and a “Scan me” legend.',
      img: bgImg3,
    },
  ],
  [
    {
      id: 4,
      text: 'Then, select colors that match the identity of your business or restaurant.',
      img: bgImg4,
    },
    {
      id: 5,
      text: 'Click “Download” and receive your QR code in .jpeg format in seconds.',
      img: bgImg5,
    },
    {
      id: 6,
      text: 'Finally, integrate your new QR code into your menu design.',
      img: bgImg6,
    },
  ],
];

export default function CreateQrCodeSteps() {
  return (
    <StyledContainer>
      <BlockTitle text="In 6 steps" hideRight />
      <StyledTitle>
        <Title type={TITLE_TYPE.h2} color={COLORS.textMain}>
          How to Create a QR Code for Menus?
        </Title>
      </StyledTitle>
      <StyledCardsWrapper>
        {LIST.map((arr, index) => (
          <StyledThreeCards key={index}>
            {arr.map(({ id, text, img }) => (
              <Card key={id} img={img} text={text} id={id} />
            ))}
          </StyledThreeCards>
        ))}
      </StyledCardsWrapper>
    </StyledContainer>
  );
}
